import React from "react";
//#region types
import { SelectionItem } from "models/utilTypes/selectionTypes";
import { FormFieldProps, MultiSelectionChipsExtraProps } from "models/propTypes/genericFormProps";
//#endregion
//#region components
import ReadOnlyField from "../baseFields/readOnlyField";
import MultipleSelection from "../../selection/multipleSelection";
//#endregion
import cssExports from "theme/styles/main.module.scss";

function MultiSelectionChipsFormField<T extends Record<string, any>>(props: FormFieldProps<T>) {
  const { name, field, value, handleOnChangeCustom, handleOnBlurCustom, disabled, readonly } = props;

  React.useImperativeHandle(props.fieldRef, () => ({
    change: (selectedItems: SelectionItem[]) => {
      onChangeHandler(selectedItems);
    },
  }));

  const extraProps = field.extraProps as MultiSelectionChipsExtraProps;

  const onChangeHandler = (selectedItems: SelectionItem[]) => {
    handleOnChangeCustom(name, selectedItems);
    handleOnBlurCustom(name);
  };

  return readonly ? (
    <ReadOnlyField label={props.field.label} href={field.href} className={cssExports.readOnlyTextField}>
      {value?.map((v: SelectionItem) => v.value).join(", ") ?? ""}
    </ReadOnlyField>
  ) : (
    <MultipleSelection
      title={props.field.label}
      items={extraProps.items}
      value={value ?? []}
      onChange={onChangeHandler}
      className={field.classes?.input}
      disabled={disabled}
      restrictMultiple={extraProps.restrictMultiSelection}
      disabledItems={extraProps.disabledItems}
    />
  );
}

export default MultiSelectionChipsFormField;
